<template>
	<search-list ref="sl" :where="where" api-path="/offerLog/list" :order="[order]" :searchKeys="searchKeys" :handleResponse="handleResponse" notSearchAll>
		<mm-lc title="Adv">
			<mm-adv-select no_paused v-model="where.adv_id" multiple />
		</mm-lc>
		<mm-lc title="UTC+8">
			<el-switch v-model="where.utc_8"></el-switch>
		</mm-lc>
		<mm-lc title="Period">
			<mm-date-range date-value v-model="where.create_at"/>
		</mm-lc>
		<mm-lc title="Period Model">
			<mm-report-select-model v-model="where.period_model" :clearable="false"/>
		</mm-lc>
		<mm-lc title="Group Model">
			<mm-log-group-model v-model="where.group_model" :clearable="false"/>
		</mm-lc>

		<mm-table slot="dataTable" slot-scope="res" :res="res" @sort-change="sortChange">
			<el-table-column label="Time" key="time" v-if="shows.time" min-width="140">
				<template slot-scope="sp">
					<el-row>{{timeFormat(sp.row.time)}}</el-row>
				</template>
			</el-table-column>
			<el-table-column label="Adv Id" prop="adv_id"/>
			<el-table-column label="Adv Name" prop="adv_name">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" row_type="adv" />
			</el-table-column>
			<el-table-column label="Offer Id" prop="offer_id" min-width="150" key="offer_id" v-if="shows.offer_id">
				<mm-get-detail slot-scope="sp" row_type="offer" :row_id="sp.row.offer_id" :row_name="sp.row.offer_id" />
			</el-table-column>
			<el-table-column label="Adv Offer Id" prop="adv_offer_id" key="adv_offer_id" v-if="shows.offer_id"/>
			<el-table-column label="total" prop="total" sortable="custom"/>
			<el-table-column label="toActive" prop="toActive"/>
			<el-table-column label="toPaused" prop="toPaused"/>
			<el-table-column label="niceToActive" prop="niceToActive"/>
			<el-table-column label="niceToPaused" prop="niceToPaused"/>
		</mm-table>
	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			offer_id: { label: "Offer Id" },
			adv_offer_id: { label: "Adv Offer Id" }
		};
		return {
			where: {
				utc_8: true,
				period_model: 'hourly',
				group_model: 'adv_id'
			},
			order: {},
			searchKeys,
			shows: {
				offer_id: false,
				time: false,
			}
		};
	},
	methods: {
		timeFormat(date) {
			if (this.where.utc_8) {
				date = new Date(new Date(date).getTime() + 8 * 3600 * 1000);
			} else {
				date = new Date(date);
			}
			let mon = date.getUTCMonth() + 1;
			let day = date.getUTCDate();
			mon = mon < 10 ? '0' + mon : mon;
			day = day < 10 ? '0' + day : day;
			if(this.where.period_model === 'daily') {
				return `${mon}-${day}`;
			} else {
				let hour = date.getUTCHours();
				hour = hour < 10 ? '0' + hour : hour;
				return `${mon}-${day} ${hour}:00`;
			}
		},
		handleResponse(body){
			for(const show in this.shows) {
				if(body.rows && body.rows[0] && body.rows[0][show] != null) {
					this.shows[show] = true;
				} else {
					this.shows[show] = false;
				}
			}
		},
		async sortChange(column){
			const order = this.order;
			if(column.order == 'ascending'){
				order.field = column.prop;
				order.order = 'asc';
			}else if(column.order == 'descending'){
				order.field = column.prop;
				order.order = 'desc';
			} else {
				order.field = null;
				order.order = null;
			}
			await this.$refs.sl.refresh();
		},
	}
};
</script>

<style scoped>
.edit-camp {
	width: 400px;
	height: 500px;
}
.el-form-item {
	width: 500px;
}
.search-condition {
	display: flex;
	flex-direction: column;
}
.row {
	display: flex;
	flex-direction: row;
	margin-bottom: 5px;

}
</style>


